exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-orange{background-color:orange!important;color:#fff!important}", ""]);

// exports
